module.exports = __webpack_public_path__ + "img/scan-code.34f566db.png";